import React, {Component} from "react";
import {render} from "react-dom";
import {browserHistory, Router, Route, IndexRoute, Link} from 'react-router';
import $ from 'jquery';
import _ from 'lodash';

import Header from './components/_header';
import Footer from './components/_footer';
import Navigation from './components/_navigation';

import data from './data';

import Index from './index';
import About from './about';
import Member from './member';
import Project from './project';
import Opinion from './opinion';
import Guide from './guide';

import Tags from './tags';
import Articles from './articles';

class App extends Component {

	constructor(props) {
		super(props);
		this.state = {
      isPagesLoaded: false,
      isMediaLoaded: false,
      isLoaded: false,
      fbFeed: '',
      article: [],
      articleMember: [],
      articleOpinion: [],
      tags: [],
      perPage: data.val.per_page,
      pageCount: data.val.page,
      pageCountM: data.val.page,
      pageCountO: data.val.page
    };
    this.getNextArticleList = this.getNextArticleList.bind(this);
	}

	componentWillMount() {

    let it = this;
    $.ajaxSetup({cache: true});
    $.getScript('//connect.facebook.net/en_US/sdk.js', function () {
      FB.init({
        appId: '1715470391796749',
        xfbml      : true,
        version    : 'v2.9'

      });
      FB.api(
        '/GIDS.GIDS.GIDS?access_token=1715470391796749|BefN08Ia1LRVPmt5ktORLaLEx-4',
        'GET',
        {"fields": "id,name,feed"},
        function (response) {
          it.setState({fbFeed: response});
        }
      );
    });
    $.ajax({
      url: data.paths[0].LIMIT_POST_URI,
      dataType: 'json'
    }).done(function (data) {
      console.log(data)
      it.setState({article: data});
    });

    $.ajax({
      url: data.paths[0].TAGS_URI,
      dataType: 'json'
    }).done(function (data) {
      it.setState({tags: data});
    })

    $.ajax({
      url: data.paths[0].MEMBER_URI,
      dataType: 'json'
    }).done(function (data) {
      it.setState({articleMember: data});
    })

    $.ajax({
      url: data.paths[0].OPINION_URI,
      dataType: 'json'
    }).done(function (data) {
      it.setState({articleOpinion: data});
    })

  }

  getNextArticleList(){

	  let it = this;
    let hash = location.pathname.replace('\/tags\/','');
    if (hash === 'MEMBER'){
      let nextPage = this.state.pageCountM + 1;
      it.setState({ pageCountM: nextPage });
      $.ajax({
        url: data.paths[0].MEMBER_URI + '&page=' + nextPage,
        dataType: 'json'
      }).done(function(data) {
        console.log(data);
        let newArr = _.union(it.state.articleMember, data);
        if (data.length === 0) {
          $('#getmore').remove();
        } else {
          it.setState({ articleMember : newArr });
        }
      });
    } else if (hash === 'OPINION'){
      let nextPage = this.state.pageCountO + 1;
      it.setState({ pageCountO: nextPage });
      $.ajax({
        url: data.paths[0].OPINION_URI + '&page=' + nextPage,
        dataType: 'json'
      }).done(function(data) {
        console.log(data);
        let newArr = _.union(it.state.articleOpinion, data);
        if (data.length === 0) {
          $('#getmore').remove();
        } else {
          it.setState({ articleOpinion : newArr });
        }
      });
    } else {
      let nextPage = this.state.pageCount + 1;
      it.setState({ pageCount: nextPage });
      $.ajax({
        url: data.paths[0].LIMIT_POST_URI + '&page=' + nextPage,
        dataType: 'json'
      }).done(function(data) {
        console.log(data);
        let newArr = _.union(it.state.article, data);
        if (data.length === 0) {
          $('#getmore').remove();
        } else {
          it.setState({ article : newArr });
        }
      });
    }

  }

	render() {
    let fixbg = this.state.isFixedBg ? 'fixedBg' : '';
		return (
				<div className={fixbg}>
          <Header />
          {this.props.children && React.cloneElement(this.props.children, {
            feed: this.state.fbFeed,
            article: this.state.article,
            articleMember: this.state.articleMember,
            articleOpinion: this.state.articleOpinion,
            tags: this.state.tags,
            page: this.state.pageCount,
            onEventCallBack: this.getNextArticleList
          })}
          <Navigation />
          <Footer />
				</div>
		)
	}
}

render((
		<Router history={browserHistory}>
			<Route path="/" component={App}>
				<IndexRoute component={Index} />
				<Route path="/aboutus" component={About}/>
				<Route path="/tags/PROJECT" component={Project}/>
				<Route path="/tags/MEMBER" component={Member}/>
				<Route path="/tags/OPINION" component={Opinion}/>
				<Route path="/guide" component={Guide}/>
        <Route path="/tags/:tag" component={Tags}/>
        <Route path="/articles/:article" components={Articles}></Route>
			</Route>
		</Router>
), document.getElementById('main'));



// WEBPACK FOOTER //
// ./src/js/main.js